<script lang="ts">
    import data from "../../../Data/SocialApp/SocialApp.json"
    import {  Col, Row } from "sveltestrap";
    import Card from "../../Core/Card.svelte";
    import { HobbiesandInterests } from "../../../utils/Constant/Constant";
    import FeatherIcon from "svelte-feather-icon"
</script>
<Col sm="12">
  <Card cardHeaderprops="social-header" cardBodyprops="pt-0">
    <div slot="customheader">
      <h5> 
        <span>{HobbiesandInterests}</span>
        <span class="pull-right">
          <FeatherIcon icon="more-vertical" />
        </span>
      </h5>
    </div>
    <div slot="contentbody">
      {#each data.hobbiesdata as intrest}
        <Row class="details-about">
          {#each intrest.intrestdatas as intrestItem }
            <Col sm="6" >
              <div class="your-details {intrestItem.class}">
                <span class="f-w-600 mb-2 d-block">{intrestItem.title}</span>
                <p>{intrestItem.detail}</p>
              </div>
            </Col>
          {/each}
        </Row> 
      {/each}
  </div>
  </Card>
</Col>